
import { Box } from 'ui/box';

import MonitoringDashboard from 'containers/user/critical-elements-monitoring/monitoring-dashboard';

interface MonitoringTabProps {
  clientId: string;
}

const MonitoringTab = ({ clientId }: MonitoringTabProps): React.JSX.Element => (
  <Box
    sx={{ mt: 2.5, display: 'flex', flexDirection: 'column', flex: '1 1 0%' }}
  >
    <MonitoringDashboard
      key={clientId}
      clientId={clientId}
      isAnalyticsEnabled={false}
    />
  </Box>
);

export default MonitoringTab;
